import createAddFieldsForCertifcate from '@/functions/createAddFieldsForCertifcate'
import createAddFieldsForAbonement from '@/functions/createAddFieldsForAbonement'

import { TypeCertificateObj, TypeAbonementObj } from "@/types/typesOfApi";

export default function sortedLoyalityByTitle(
  loyality: TypeCertificateObj[] | TypeAbonementObj[],
  resultObjNames: any,
  loyalityKind: string
) {
  loyality.forEach((item: any) => {
    const currentTilteSplit = item.title.replace(/\s+/g, "_").split("/");
    if (
      resultObjNames[currentTilteSplit[0]] &&
      !resultObjNames[currentTilteSplit[0]].list.find(
        (i: any) => i.id === item.id
      )
    ) {
      resultObjNames[currentTilteSplit[0]].list.push(item);
    }

    if (!resultObjNames[currentTilteSplit[0]]) {
      resultObjNames[currentTilteSplit[0]] = { list: [], id: Math.random() };
      resultObjNames[currentTilteSplit[0]].list.push(item);
    }
  });

  if (loyalityKind === "certificate") {
    createAddFieldsForCertifcate(resultObjNames);
  } else if (loyalityKind === "abonement") {
    createAddFieldsForAbonement(resultObjNames);
  }
}
